namespace GeniuzPOS.InitialData {
    export interface PsSalesmanForm {
        SalesmanId: Serenity.StringEditor;
        SalesmanGroup: Serenity.LookupEditor;
        SalesmanName: Serenity.StringEditor;
    }

    export class PsSalesmanForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsSalesman';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsSalesmanForm.init)  {
                PsSalesmanForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(PsSalesmanForm, [
                    'SalesmanId', w0,
                    'SalesmanGroup', w1,
                    'SalesmanName', w0
                ]);
            }
        }
    }
}
